import { CommonModule }     from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule }         from '@angular/core';

import { CopyToClipboardDirective }     from './copy-to-clipboard/copy-to-clipboard.component';
import { FormSubmitValidatorDirective } from './form-submit.validator.directive';
import { TooltipDirective }             from './tooltip.directive';

@NgModule({
  declarations: [
    CopyToClipboardDirective,
    FormSubmitValidatorDirective,
    TooltipDirective
  ],
  entryComponents: [
    CopyToClipboardDirective
  ],
  exports: [
    // Third Party
    NgbTooltipModule,

    // Custom
    CopyToClipboardDirective,
    FormSubmitValidatorDirective,
    TooltipDirective
  ],
  imports: [
    // Angular
    CommonModule,

    // Third Party
    NgbTooltipModule
  ]
})
export class DirectivesModule {}
